(function () {
  'use strict';

  function initPdpGallery() {
    document.querySelectorAll('product-info').forEach(function (productInfo) {
      var mappingEl = productInfo.querySelector('script[id^="ProductMedia-"]');
      if (!mappingEl) return;

      var data;
      try { data = JSON.parse(mappingEl.textContent); } catch (e) { return; }

      var mediaOrder = data.mediaOrder || [];
      var featuredMediaMap = data.featuredMediaMap || {};

      // Sorted positions of every variant's featured image in the media array
      var starterIdSet = {};
      Object.keys(featuredMediaMap).forEach(function (vId) {
        starterIdSet[featuredMediaMap[vId]] = true;
      });
      var starterPositions = [];
      mediaOrder.forEach(function (id, i) {
        if (starterIdSet[id]) starterPositions.push(i);
      });
      starterPositions.sort(function (a, b) { return a - b; });

      // Images before the first variant starter = shared, always visible
      var firstStarterPos = starterPositions.length ? starterPositions[0] : mediaOrder.length;

      function getVisibleSet(variantId) {
        var visible = {};
        for (var i = 0; i < firstStarterPos; i++) visible[mediaOrder[i]] = true;

        var featuredId = featuredMediaMap[String(variantId)];
        if (!featuredId) return visible;

        var startPos = mediaOrder.indexOf(featuredId);
        if (startPos === -1) return visible;

        var endPos = mediaOrder.length;
        for (var j = 0; j < starterPositions.length; j++) {
          if (starterPositions[j] > startPos) { endPos = starterPositions[j]; break; }
        }
        for (var k = startPos; k < endPos; k++) visible[mediaOrder[k]] = true;

        return visible;
      }

      function getSelectedVariantId() {
        var el = productInfo.querySelector('[data-selected-variant]');
        if (!el) return null;
        try { return JSON.parse(el.textContent).id; } catch (e) { return null; }
      }

      function applyFilter(variantId) {
        if (!variantId) return;
        var visible = getVisibleSet(variantId);
        productInfo.querySelectorAll('.product__media-list li[data-raw-media-id]').forEach(function (slide) {
          slide.hidden = !visible[parseInt(slide.dataset.rawMediaId, 10)];
        });
        productInfo.querySelectorAll('.thumbnail-list li[data-raw-media-id]').forEach(function (thumb) {
          thumb.hidden = !visible[parseInt(thumb.dataset.rawMediaId, 10)];
        });

        // Recalculate mobile slider state after hiding/showing slides — equivalent to swiper.update()
        var viewer = productInfo.querySelector('[id^="GalleryViewer-"]');
        if (viewer && typeof viewer.resetPages === 'function') {
          viewer.resetPages();
        }
        var thumbnailsEl = productInfo.querySelector('[id^="GalleryThumbnails-"]');
        if (thumbnailsEl && typeof thumbnailsEl.resetPages === 'function') {
          thumbnailsEl.resetPages();
        }

        // Navigate to the variant's featured image immediately — don't wait for the server fetch
        var featuredId = featuredMediaMap[String(variantId)];
        if (featuredId) {
          var mediaGallery = productInfo.querySelector('media-gallery');
          if (mediaGallery && mediaGallery.setActiveMedia) {
            mediaGallery.setActiveMedia(data.sectionId + '-' + featuredId, false);
          }
        }
      }

      var initialVariantId = getSelectedVariantId();
      if (initialVariantId) applyFilter(initialVariantId);

      subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function (event) {
        if (!productInfo.contains(event.data.event.target)) return;
        var variantId = getSelectedVariantId();
        if (variantId) applyFilter(variantId);
      });

      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (event.data.sectionId !== data.sectionId) return;
        var variantId = event.data.variant && event.data.variant.id;
        if (variantId) applyFilter(variantId);
      });

      function preloadHiddenImages() {
        productInfo.querySelectorAll('li[data-raw-media-id][hidden] img[src]').forEach(function (img) {
          var preload = new Image();
          preload.src = img.src;
        });
      }
      if ('requestIdleCallback' in window) {
        requestIdleCallback(preloadHiddenImages);
      } else {
        setTimeout(preloadHiddenImages, 2000);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initPdpGallery);
})();
